import { useSearchParams } from 'react-router-dom'
// import store from 'store'
import md5 from 'js-md5'
import user from '@/stores/user'

// url获取手机号码
const useValidateCmcc = () => {
  const [searchParams] = useSearchParams()
  const from = searchParams.get('from') || ''
  // from && (user.from = from)
  if (from === user.from) {
    console.log('在合家亲APP内', user.from)
  } else {
    return
  }
  const phoneNumber = searchParams.get('phoneNumber') || ''
  const sign = searchParams.get('sign') || ''
  // if (phoneNumber && phoneNumber !== 'undefined') {
  //   store.set('phoneNumber', phoneNumber)
  // } else {
  //   !store.get('phoneNumber') && Toast.show('手机号不正确')
  // }
  const checkPhoneNumber = (phoneNumber: string, from: string = 'CMCC', sign: string) => {
    const secret = 'Jupiter#YIewwUP5Df(5*mjBjyxq(sffJshM2S'
    return md5(`phoneNumber=${phoneNumber}&from=${from}&secret=${secret}`) === sign
  }

  if (checkPhoneNumber(phoneNumber, from, sign)) {
    user.phoneNumber = phoneNumber
  }
}

// ?phoneNumber=13755751401&from=CMCC&sign=ca105f7464e73fee11fffad2c773e8da

export default useValidateCmcc
